import React from 'react'
import BuildingSearch from 'components/utility/building_search'
import chubbLogo from '/app/assets/images/insurance/logos/chubb.png'
import lemonadeLogo from '/app/assets/images/insurance/logos/lemonade.png'
import viaffinityLogo from '/app/assets/images/insurance/logos/viaffinity.png'

const SUGGESTIONS_URL = '/insurance/buildings/lookup_buildings'

function InsuranceBuildingSearch({ onBuildingSelect }) {
  return (
    <>
      <div className="instant-quote-header dome-h3 dome-color-green-gradient">insurance for your home</div>
      <div className="dome-d-flex dome-gap3 dome-align-center lookup-logos">
        <em>insurance provided by</em>
        <img src={chubbLogo} style={{ width: '63px', height:'6px', objectFit: 'contain' }} />
        <img src={lemonadeLogo} style={{ width: '41px', height: '9px', objectFit: 'contain' }} />
        <img src={viaffinityLogo} style={{ width: '60px', objectFit: 'contain' }} />
      </div>
      <div className="search-wrapper dome-d-flex dome-flex-column">
        <div className="search-wrapper-text dome-p3" style={{ fontSize: '12px' }}>
          <div className="dome-d-flex dome-align-center dome-gap6">
            <i className="far fa-check dome-color-sage" />
            <span>matches building requirements</span>
          </div>
          <div className="dome-d-flex dome-align-center dome-gap6">
            <i className="far fa-check dome-color-sage" />
            <span>no personal info needed for estimate</span>
          </div>
          <div className="dome-d-flex dome-align-center dome-gap6">
            <i className="far fa-check dome-color-sage" />
            <span>policy auto uploads to library </span>
          </div>
        </div>
        <BuildingSearch
          show_empty_message={true}
          show_magnifying_glass={true}
          url={SUGGESTIONS_URL}
          classes={{
            iconClass: 'fa-light fa-magnifying-glass search-icon',
            containerClass: 'search-container',
            inputClass: 'search-container-search',
            searchBarBorderClass: 'searchbar-border-sm',
          }}
          placeholderText="find your property's estimate"
          onSelect={onBuildingSelect}
          customEmptyMessage={
            <>
              <div>
                It looks like insurance is not available for this property yet. For more information,{' '}
                <a
                  href="https://boardpackager.freshdesk.com/support/tickets/new"
                  target="_blank"
                  className="dome-link dome-link-aqua"
                >
                  contact us.
                </a>
              </div>
            </>
          }
        />
      </div>
      <em className='dome-p5-lt dome-color-dark-grey' style={{display: 'inline-block', marginTop: '13px'}}>
        Insurance underwritten by third party providers. This link is provided through a beneficial relationship with Domecile for your convenience and is not an endorsement.
      </em>
    </>
  )
}

export default InsuranceBuildingSearch
